import { LexicalEditor } from 'lexical';
import { useFormContext, Controller } from 'react-hook-form';
import { FormControl, FormHelperText } from '@mui/material';
import CasSimpleLexicalRichTextEditor from './CasSimpleLexicalRichTextEditor';
import CasLexicalRichTextEditor from './lexical-playground/src/CasLexicalRichTextEditor';
import { IDataTableConfig } from './CasPlugins/CasTableDataPlugin/CasTableDataNode';

type Props = {
  name: string;
  label?: string;
  helperText?: string;
  placeholder?: string;
  mode?: 'full' | 'simple' | 'advanced';
  dataTableConfig?: IDataTableConfig;
  onReadyEditor?: React.Dispatch<React.SetStateAction<LexicalEditor | null>>;
};

export default function CasRHFLexicalRichTextEditor({
  name,
  label,
  helperText,
  placeholder,
  mode,
  dataTableConfig,
  onReadyEditor,
}: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState: { error } }) => (
        <FormControl className="rhf-editor-wrapper" fullWidth error={!!error}>
          {mode === 'advanced' ? (
            <CasLexicalRichTextEditor
              label={label}
              placeholder={placeholder}
              isError={!!error}
              initialValue={field.value}
              onChange={field.onChange}
              dataTableConfig={dataTableConfig}
              onReadyEditor={onReadyEditor}
            />
          ) : (
            <CasSimpleLexicalRichTextEditor
              label={label}
              placeholder={placeholder}
              isError={!!error}
              initialValue={field.value}
              onChange={field.onChange}
              mode={mode}
            />
          )}
          {(!!error || helperText) && (
            <FormHelperText error={!!error}>{error ? error.message : helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
